import BusinessContentCommentListContainer from './BusinessContentCommentListContainer';


const businessContentCommentContainers = [
  {path: "/business-content-comment/list", component: BusinessContentCommentListContainer,}
]

export default businessContentCommentContainers
